/* import __COLOCATED_TEMPLATE__ from './entries-table-details-row.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class EntriesTableDetailsRowComponent extends Component 
{	
	@action
	edit()
	{
		if (!this.args.entry) {
			return;
		}
		this.args.entry.set('showDetails',false);
		this.args.entry.set('isEditing',true);
	}
	
	@action
	async clearIntermediate(intermediateTimingRecord)
	{
		intermediateTimingRecord.EntryId = null;
		
		try
		{
			await intermediateTimingRecord.save();
		}
		catch (error)
		{
			alert(error);
			intermediateTimingRecord.EntryId = this.args.entry;
		}
	}
}